import React, { useState } from 'react';
import { useAppDispatch } from '../../../app/hooks';
import { fetchIntegrationData } from '../../../app/thunks/fetch-integration-data';
import { ReactComponent as IDAustriaLogo } from '../../../assets/images/IDAustriaLogoNoText.svg';
import { useAppTranslation } from '../../../i18n';

const TRANSLATION_PREFIX = 'steps.bank-auth-type-selection';

export const IDAustriaButton = () => {
	const { t } = useAppTranslation();
	const dispatch = useAppDispatch();
	const [submitting, setSubmitting] = useState<boolean>(false);

	const onClickIDAustria = async () => {
		try {
			setSubmitting(true);
			await dispatch(fetchIntegrationData());
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div id="id-autria-auth" className="flex w-full justify-between items-start -ml-[0.4rem]">
			<div className="flex items-start min-w-0">
				<IDAustriaLogo height={50} />
				<div className="flex flex-col items-start -ml-[5rem] mt-2">
					<p className="text-sm font-[600] text-black">{t(`${TRANSLATION_PREFIX}.id-austria-title`)}</p>
					<p className="text-sm font-semi-bold italic whitespace-pre-line">
						{t(`${TRANSLATION_PREFIX}.id-austria-description`)}
					</p>
				</div>
			</div>

			<button
				onClick={onClickIDAustria}
				disabled={submitting}
				aria-label={`${t('button.next')} – ${t(`${TRANSLATION_PREFIX}.id-austria-title`)}`}
				className="text-sm font-semi-bold border px-1 -mr-2 py-0.5 rounded-md mt-1 border-gray-600 hover:bg-gray-100 disabled:opacity-50 flex-shrink-0"
			>
				{t('button.next')}
			</button>
		</div>
	);
};

export default IDAustriaButton;
